import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/App';
import {
  LayoutDashboard,
  Store,
  FileText,
  LogOut,
  Shield,
  MessageCircle,
  Bell
} from 'lucide-react';

const LOGO_URL = "/logo-adegga.png";

const navItems = [
  { path: '/admin/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { path: '/admin/lojas', label: 'Lojas', icon: Store },
  { path: '/admin/templates', label: 'Templates', icon: FileText },
  { path: '/admin/suporte', label: 'Suporte', icon: MessageCircle },
  { path: '/admin/notificacoes', label: 'Notificações', icon: Bell },
  { path: '/admin/usuarios', label: 'Administradores', icon: Shield },
];

export const AdminLayout = ({ children, title }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return (
    <div className="min-h-screen bg-[#1a1a2e] flex">
      {/* Sidebar */}
      <div className="w-64 fixed h-screen bg-[#0a0a0f] border-r border-white/5">
        <div className="p-4 border-b border-white/5">
          <img src={LOGO_URL} alt="ADEGGA" className="h-10 object-contain" />
          <span className="text-xs text-[#ff6b00] mt-1 block">ADMIN</span>
        </div>
        
        <nav className="p-2 space-y-1">
          {navItems.map(item => (
            <Link
              key={item.path}
              to={item.path}
              className={`sidebar-item ${location.pathname === item.path ? 'active' : ''}`}
              data-testid={`admin-nav-${item.path.split('/').pop()}`}
            >
              <item.icon className="w-5 h-5" />
              <span>{item.label}</span>
            </Link>
          ))}
        </nav>
        
        <div className="absolute bottom-0 left-0 right-0 p-2 border-t border-white/5">
          <button
            onClick={handleLogout}
            className="sidebar-item w-full text-red-400 hover:text-red-300 hover:bg-red-500/10"
            data-testid="admin-logout-btn"
          >
            <LogOut className="w-5 h-5" />
            <span>Sair</span>
          </button>
        </div>
      </div>
      
      {/* Main Content */}
      <div className="flex-1 ml-64">
        <header className="sticky top-0 z-40 bg-[#1a1a2e]/95 backdrop-blur-md border-b border-white/5 px-6 py-4">
          <div className="flex items-center justify-between">
            <h1 className="text-xl font-bold text-white">{title}</h1>
            <div className="flex items-center gap-3">
              <span className="text-sm text-white/60">{user?.name}</span>
              <div className="w-8 h-8 rounded-full bg-[#ff6b00] flex items-center justify-center text-white font-bold text-sm">
                {user?.name?.charAt(0).toUpperCase()}
              </div>
            </div>
          </div>
        </header>
        
        <main className="p-6">
          {children}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
